module.exports = __webpack_public_path__ + "img/no_address.be9c6695.svg";